module.exports = __webpack_public_path__ + "016811bb3afa36714c1b368d94b5729e.woff2";